// Module
var code = "<div paginated-tabs=\"s in viewConfig.standards\" paginated-tabs-group=\"byStandard\" shift-size=\"page\" static-position=\"true\">\n    <div class=\"rotated-heading\" title=\"{{s.title}}\">{{ s.name.substr(-15) }}</div>\n</div>\n";
// Exports
module.exports = code;